import { isNumber } from '@/utils/checks'
import { MAX_BUDGET_PACING } from './constants'

export const adjustPacing = (budgetPacing: number = 10000): number => {
  if (isNumber(budgetPacing) && budgetPacing > 0) {
    return -Math.min(budgetPacing, MAX_BUDGET_PACING)
  }
  return -10000
}
